import React, { ReactNode } from 'react';
import parseHtml from 'html-react-parser';
import { Translation } from '~/shared/types/translation';
import { getLcn } from '~/utils/labeled-classnames';
import stringToParagraphs from '~/utils/stringToParagraphs';
import { isString } from 'lodash-es';

export default function TranslationWrapper({
  translation,
  html = false,
  wrap = true,
  replacements,
}: {
  translation: Translation,
  html?: boolean
  wrap?: boolean
  replacements?: { [key: string]: string | number }
}) {
  const lcn = getLcn({
    translationWrapper: ''
  });

  const defaultReplacements = {
    '&#39;': "'", // some translations have &#39; instead of ' for some reason (from google)
  };

  replacements = { ...defaultReplacements, ...replacements };

  let parts: string[] | ReactNode[] = []

  let text = translation.text;

  // will need to extract this to a utility function when we do ts
  if (isString(translation.text)) {
    // insert replacements into text
    Object.entries(replacements).forEach(([replacing, replacement]) => {
      text = text.replaceAll(replacing, String(replacement))
    });
  }

  if (typeof text === 'object') {
    parts = [text]
  } else if (html) {
    parts = [parseHtml(text || '')]
  } else {
    parts = stringToParagraphs(text || '')
  }

  if (!wrap) return parts

  return (
    parts.map((part, index) => (
      <span
        className={lcn.translationWrapper}
        data-locale={translation.locale}
        data-label={translation.label}
        data-id={translation.id}
        data-paragraph={index}
        key={index}>
        {part}
      </span>
    ))
  )
};